import { useGetNotesQuery } from '@carboncopyco/data';
import type { NoteEntityType } from '@carboncopyco/types';
import { useParams } from 'react-router-dom';

type UseSpeakerNotesProps = {
  entityType: NoteEntityType;
  entityId: string;
};

export const useSpeakerNotes = ({
  entityType,
  entityId,
}: UseSpeakerNotesProps) => {
  const { organizationId } = useParams();
  const {
    data: notes,
    isLoading,
    error,
  } = useGetNotesQuery({
    organizationId,
    entityType,
    entityId,
  });
  const note = notes?.[0];
  return { note, isLoading, error };
};
